import type { HTMLAttributes } from 'react';

export function Badge({ className = '', children, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span {...props} className={`inline-flex items-center rounded-md bg-primary/10 px-2 py-1 text-xs font-medium text-primary ${className}`}>{children}</span>;
}
